import { nanoid } from 'nanoid';
import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Rect, Path } from 'react-native-svg';

const HomeIcon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    const gradientId = nanoid();

    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 43}
          height={props.height ?? 38}
          viewBox="0 0 43 38"
          fill="none"
          {...props}
        >
          <Rect width="43" height="38" rx="8" fill={props.color ?? '#FFF5DD'} />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5015 4.50781L5.59375 20.0737L9.4749 22.1093L21.398 9.60333L33.5282 22.1119L37.4093 20.0763L21.5015 4.50781ZM10.3216 22.518L21.5171 11.3311L32.6789 22.518V33.4928H24.5257V25.7409H18.4075V33.4928H10.3216V22.518Z"
            fill="#453B3B"
          />
        </Svg>
      </View>
    );
  },
);

export { HomeIcon };
